<ng-container *ngIf="nav" [ngSwitch]="nav.style">
  <ng-container *ngSwitchCase="'sub'">
    <flo-nav-sub [nav]="nav" [selectedLink]="selectedLink" [tagName]="tagName" (linkClicked)="handleLinkClicked($event)"></flo-nav-sub>
  </ng-container>
  <ng-container *ngSwitchCase="'fly-out'">
    <flo-nav-fly-out [nav]="nav"></flo-nav-fly-out>
  </ng-container>
</ng-container>
